import React, { Component } from "react";
import "./breadcrumbs-item.css";

export default class BreadcrumbsItem extends Component {
    static get defaultProps() {
        return {
            onClick: null,
            isActive: false,
        };
    }

    static get propTypes() {
        return {
            id: React.PropTypes.oneOfType([
                React.PropTypes.number,
                React.PropTypes.string,
            ]).isRequired,
            onClick: React.PropTypes.func,
            isActive: React.PropTypes.bool,
            disabled: React.PropTypes.bool,
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            isHover: false
        };
    }

    handleClick() {
        if (this.props.onClick !== null && !this.props.disabled) {
            this.props.onClick(this.props.id);
        }
    }

    handleMouseOver() {
        this.setState({ isHover: true });
    }

    handleMouseOut() {
        this.setState({ isHover: false });
    }

    render() {
        const colors = this.context.muiTheme.palette;
        let backgroundColor = colors.primary2color;

        if ((this.state.isHover && !this.props.disabled) || this.props.isActive) {
            backgroundColor = colors.accent4color;
        }

        return (
            <div
                className="appointment-breadcrumbs-item"
                onMouseOver={() => this.handleMouseOver()}
                onMouseOut={() => this.handleMouseOut()}
                onClick={() => this.handleClick()} style={{
                    cursor: this.props.onClick !== null || this.state.isHover ? "pointer" : "default",
                    backgroundColor: backgroundColor
                }}>

                <div className="appointment-breadcrumbs-item__text">
                    {this.props.children}
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/breadcrumbs-item.js
 **/